import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69839e76"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cont_main_top" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "arrow_b",
  src: "/assets/icon/btn_back.png",
  srcset: "/assets/icon/btn_back@2x.png 2x,/assets/icon/btn_back@3x.png 3x"
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cont_main_title" }, [
  /*#__PURE__*/_createElementVNode("div", null, "서명중")
], -1))
const _hoisted_5 = {
  key: 0,
  class: "content"
}
const _hoisted_6 = {
  class: "empty_box blue_bg",
  style: {"background-image":"url('/assets/image/asset_bg_img.png')"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "box_title" }, " 서명하실 계약건이 없습니다 "),
  /*#__PURE__*/_createElementVNode("div", { class: "box_info" }, " 매력적인 스타트업의 주주가 되어보세요! ")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "angel_man",
    src: "/assets/image/orange_richie.png",
    srcset: "/assets/image/orange_richie@2x.png 2x,/assets/image/orange_richie@3x.png 3x"
  })
], -1))
const _hoisted_9 = {
  key: 1,
  class: "content"
}
const _hoisted_10 = { class: "content_top" }
const _hoisted_11 = { class: "bold" }
const _hoisted_12 = { class: "col_left" }
const _hoisted_13 = { class: "c_logo" }
const _hoisted_14 = ["src"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inset-border" }, null, -1))
const _hoisted_16 = { class: "col_right" }
const _hoisted_17 = { class: "space-between" }
const _hoisted_18 = { class: "regular bold" }
const _hoisted_19 = { class: "space-between" }
const _hoisted_20 = { class: "gray" }
const _hoisted_21 = { class: "space-between" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "서명 완료 현황", -1))
const _hoisted_23 = { class: "red" }
const _hoisted_24 = { class: "last_child space-between" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "투자 금액", -1))
const _hoisted_26 = { class: "strong" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_28 = { class: "right_div" }
const _hoisted_29 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_refresher_content = _resolveComponent("ion-refresher-content")!
  const _component_ion_refresher = _resolveComponent("ion-refresher")!
  const _component_ion_ripple_effect = _resolveComponent("ion-ripple-effect")!
  const _component_collect_club_deals = _resolveComponent("collect-club-deals")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_refresher, {
            slot: "fixed",
            onIonRefresh: _cache[0] || (_cache[0] = ($event: any) => (_ctx.doRefresh($event)))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_refresher_content, {
                "pulling-icon": _ctx.arrowDownOutline,
                "refreshing-spinner": "crescent"
              }, null, 8, ["pulling-icon"])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", {
              class: "ion-activatable ripple-parent btn-back",
              onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.$clickTrackEvent({'clickArea':'헤더', 'clickContent':'뒤로가기', clickScreen: _ctx.clickScreen});_ctx.$router.push('/tabs/mypage')})
            }, _hoisted_3),
            _createVNode(_component_ion_ripple_effect, { type: "unbounded" }),
            _hoisted_4
          ]),
          (!_ctx.docuign)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _hoisted_8,
                  _createElementVNode("div", {
                    class: "box_btn",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.$clickTrackEvent({'clickArea':'목록', 'clickContent':'참여 가능 조합 보러가기', clickScreen: _ctx.clickScreen});_ctx.clubDealAllOpen=true;})
                  }, " 참여 가능 조합 보러가기 ")
                ])
              ]))
            : (_ctx.docuign)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, " 총 " + _toDisplayString(_ctx.docuign.length), 1)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.docuign, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item,
                      class: "content_box"
                    }, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("img", {
                            src: item.companyLogo ? item.companyLogo : '/assets/icon/company_default_img.png',
                            onerror: "this.src='/assets/icon/company_default_img.png'",
                            class: "img-responsive img-circle"
                          }, null, 8, _hoisted_14),
                          _hoisted_15
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("span", _hoisted_18, _toDisplayString(item.partnershipName), 1)
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, _toDisplayString(item.sentDateTime) + " ~ ", 1)
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          _hoisted_22,
                          _createElementVNode("div", null, [
                            _createElementVNode("span", _hoisted_23, _toDisplayString(item.completed) + "명", 1),
                            _createTextVNode(" / " + _toDisplayString(item.totalCount) + "명 ", 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                          _hoisted_25,
                          _createElementVNode("div", null, [
                            _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$filters.currency(item.realAsset)), 1),
                            _hoisted_27
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_28, [
                          (!~['completed', 'signing_complete'].indexOf(item.status))
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "blue_btn",
                                onClick: ($event: any) => {_ctx.$clickTrackEvent({'clickArea':'목록', 'clickContent':'조합규약에 서명하기', clickScreen: _ctx.clickScreen});_ctx.openLinkWithAccessTokenAndSocketId(item.docusignLink, _ctx.SOCKET_ID);}
                              }, " 조합규약에 서명하기 ", 8, _hoisted_29))
                            : (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: "gray_btn",
                                onClick: _cache[3] || (_cache[3] = ($event: any) => {_ctx.$clickTrackEvent({'clickArea':'목록', 'clickContent':'서명 완료', clickScreen: _ctx.clickScreen});})
                              }, " 서명 완료 "))
                        ])
                      ])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
          _createVNode(_component_collect_club_deals, {
            "model-value": _ctx.clubDealAllOpen,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = (value) => _ctx.clubDealAllOpen = value)
          }, null, 8, ["model-value"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}